module.exports = __webpack_public_path__ + "assets/views/04_dosingAdministration/dosingIcon3.png";